import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@teo/components';
import { useState, useEffect } from 'react';
import { axios } from '@/axios';
import { config } from '@/config';
import { useGet } from '@/query';
import AddCompetenceList from '@/components/Competencies/CreateFlow/AddCompetenceList';

const EditCompetencies = ({
  state,
  setIsOpenCompetencies,
  isOpenCompetencies,
  competencies,
  setCompetencies,
  lessonId,
}) => {
  const { t } = useTranslation();
  const [newCompetency, setNewCompetency] = useState([]);
  const [widgetCompetencies, setWidgetCompetencies] = useState([]);
  const [newWidgetCompetencies, setNewWidgetCompetencies] = useState([]);

  const [deleteList, setDeleteList] = useState([]);
  const [addList, setAddList] = useState([]);

  useGet(`/widgetcompetencedetails`, {
    widgetUid: state?.uid,
    lessonId: lessonId,
    onSuccess: (result) => {
      setWidgetCompetencies(result?.data || []);
      setNewWidgetCompetencies(result?.data || []);
    },
  });

  useEffect(() => {
    if (competencies?.length > 0) {
      setNewCompetency(competencies);
    }
  }, []);

  useEffect(() => {
    const deletedIds = new Set(deleteList.map((item) => item.competenceId));

    const result = [
      ...competencies.filter((item) => !deletedIds.has(item.id)),
      ...addList.map((item) => ({
        id: item.competenceId,
        label: item.path,
      })),
    ];

    const resultList = [
      ...widgetCompetencies.filter(
        (item) => !deletedIds.has(item.competenceId)
      ),
      ...addList.map((item) => ({
        ...item,
      })),
    ];
    setNewWidgetCompetencies(resultList);
    setNewCompetency(result);
  }, [competencies, addList, deleteList, widgetCompetencies]);

  const handleRemoveAcnive = () => {
    let placeholder = document.getElementById(state.uid);
    const divsToRemove = placeholder.getElementsByClassName('active-widget');
    Array.from(divsToRemove).forEach((div) => {
      div.remove();
    });
  };

  const commonObjects = (arr1, arr2) => {
    const competenceIds = new Set(arr2.map((item) => item.competenceId));

    return arr1.filter((item) => competenceIds.has(item.competenceId));
  };

  const handleSave = async () => {
    try {
      if (addList?.length > 0) {
        await Promise.all(
          addList.map((el) =>
            axios.post(`${config.backend}/widgetcompetences`, {
              widgetUid: state?.uid,
              lessonId: lessonId,
              competenceId: el?.competenceId,
            })
          )
        );
      }
      if (deleteList?.length > 0) {
        const result = commonObjects(widgetCompetencies, deleteList);
        await Promise.all(
          result.map((el) =>
            axios.delete(`${config.backend}/widgetcompetence/${el.id}`)
          )
        );
      }
      document.body.style.overflow = 'unset';
      handleRemoveAcnive();
      setCompetencies(newCompetency);
      setIsOpenCompetencies(false);
    } catch (error) {
      console.error('Error saving:', error);
    }
  };

  return (
    <div className="bg-white">
      <Modal isOpen={isOpenCompetencies}>
        <Modal.Header
          onClose={() => {
            document.body.style.overflow = 'unset';
            handleRemoveAcnive();
            setIsOpenCompetencies(false);
          }}
        >
          <h2 className="text-sm font-semibold">
            {t('widgets.widget_competencies.edit_competencies')}
          </h2>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-1 space-y-2 md:space-y-4">
            <AddCompetenceList
              setDeleteList={setDeleteList}
              deleteList={deleteList}
              setAddList={setAddList}
              addList={addList}
              oldCompetencies={widgetCompetencies}
              listCompetencies={newWidgetCompetencies}
              setNewLesCompetencies={setNewWidgetCompetencies}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="flex w-full">
            <Button
              variant="ghost"
              onClick={() => {
                document.body.style.overflow = 'unset';
                handleRemoveAcnive();
                setIsOpenCompetencies(false);
              }}
            >
              {t('button.cancel')}
            </Button>
            <Button onClick={() => handleSave()} className="ml-auto">
              {t('widgets.widget_competencies.save_competencies')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditCompetencies;
